import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from '@environments/environment';
import { MNZ_PLATFORM } from '@mnz-core/injectors/platform';
import { Platform, PlatformUrl } from '@mnz-core/models/_enums';
import { AppModule } from '@mnz/app.module';
import { appVersion } from '@mnz/app.version';

import { defineCustomElements } from '@nessie/webcomponents/loader';

if (environment.production) {
  enableProdMode();
}

const hostname = window.location.hostname || PlatformUrl.PRODUCTION;
const platform = hostname.includes(PlatformUrl.PRODUCTION)
  ? Platform.PRODUCTION
  : hostname.includes(PlatformUrl.ACCEPTANCE)
  ? Platform.ACCEPTANCE
  : hostname.includes(PlatformUrl.TEST)
  ? Platform.TEST
  : Platform.DEVELOPMENT;

platformBrowserDynamic([{ provide: MNZ_PLATFORM, useValue: platform }])
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));

if (environment.production) {
  enableProdMode();
}

declare let __webpack_public_path__: any;

if (
  hostname.includes(PlatformUrl.PRODUCTION) ||
  hostname.includes(PlatformUrl.ACCEPTANCE) ||
  hostname.includes(PlatformUrl.TEST)
) {
  const assetsPath = '/fe-platform-static/apps/mijnnszakelijk-frontend/' + appVersion.version + '/';

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  __webpack_public_path__ = assetsPath;
  defineCustomElements(window, {
    resourcesUrl: assetsPath,
  });
} else if (platform == Platform.DEVELOPMENT && document.location.port == '8080') {
  // set fixed assets URL voor localhost/Wicket
  const assetsPath =
    'https://www.test.ns.nl/fe-platform-static/apps/mijnnszakelijk-frontend/' + appVersion.version + '/';

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  __webpack_public_path__ = assetsPath;
  defineCustomElements(window, {
    resourcesUrl: assetsPath,
  });
} else {
  defineCustomElements();
}
